import { useCallback, useRef, useState } from 'react';

let counter = 0;
const nextKey = () => `row-${Date.now().toString(36)}-${++counter}`;

/**
 * Manages the repeating "entry table" rows used by Stock In, Stock Out and
 * Price Management. Each row carries a stable `_key` so React never reuses a
 * DOM node between two different rows when one is removed from the middle.
 */
export default function useRowEditor(makeBlankRow) {
  const blank = useRef(makeBlankRow);
  const [rows, setRows] = useState(() => [{ _key: nextKey(), ...blank.current() }]);

  const addRow = useCallback(() => {
    setRows((current) => [...current, { _key: nextKey(), ...blank.current() }]);
  }, []);

  const removeRow = useCallback((key) => {
    setRows((current) => (current.length === 1 ? current : current.filter((row) => row._key !== key)));
  }, []);

  const patchRow = useCallback((key, patch) => {
    setRows((current) => current.map((row) => (row._key === key ? { ...row, ...patch } : row)));
  }, []);

  const resetRows = useCallback(() => {
    setRows([{ _key: nextKey(), ...blank.current() }]);
  }, []);

  return { rows, addRow, removeRow, patchRow, resetRows, setRows };
}
